import React, { Fragment } from 'react'
import { ReactComponent as LogoBlack } from '../../images/logo_black.svg'
import { ReactComponent as LogoVerticalSimple } from '../../images/logo_vertical_simple.svg'
import { Link, useNavigate } from 'react-router-dom'
import { Button } from '@demandlocal/components'
import { ReactComponent as RoundedCheck } from '../../images/icons/rounded_check.svg'
import LandingFooter from '../../components/Landing/Footer'
import { ReactComponent as ChevronRight } from '../../images/icons/chevron_right.svg'
import PricingCardMobile from '../../components/Landing/PricingCardMobile'

const featuresMobile = [
  {
    title: '$ 199',
    locationBased: true,
    clientLinks: '2 Client links',
    features: [
      {
        text: '1st party audiences',
      },
      {
        text: 'Daily pushes',
      },
      {
        text: 'Daily pulls',
      },
      {
        text: '1 of any standard connection',
        children: [
          'FB Audience',
          'FB Leads',
          'Google Audience',
          'Google Leads',
          'Google Sheets',
          'CSV',
          'FTP',
        ],
      },
      {
        text: '1 inventory destination',
        children: [
          'iSEM',
          'Google VA',
          'FB Inventory',
          'Dynamic Display Ads',
          'FB Inventory Leads',
        ],
      },
    ],
  },
  {
    title: '$ 299',
    clientLinks: '3-5 Client links',
    features: [
      {
        text: '1st party audiences',
      },
      {
        text: 'Daily pushes',
      },
      {
        text: 'Daily pulls',
      },
      {
        text: 'Up to 4 of any standard connection',
        children: [
          'FB Audience',
          'FB Leads',
          'Google Audience',
          'Google Leads',
          'Google Sheets',
          'CSV',
          'FTP',
        ],
      },
      {
        text: '1 inventory destination',
        children: [
          'iSEM',
          'Google VA',
          'FB Inventory',
          'Dynamic Display Ads',
          'FB Inventory Leads',
        ],
      },
    ],
  },
  {
    title: '$ 499',
    clientLinks: 'Unlimited links 1 client',
    features: [
      {
        text: '1st party audiences',
      },
      {
        text: 'Daily pushes',
      },
      {
        text: 'Daily pulls',
      },
      {
        text: 'Unlimited connections',
        children: [
          'FB Audience',
          'FB Leads',
          'Google Audience',
          'Google Leads',
          'Google Sheets',
          'CSV',
          'FTP',
        ],
      },
      {
        text: 'Multiple inventory destinations',
        children: [
          'iSEM',
          'Google VA',
          'FB Inventory',
          'Dynamic Display Ads',
          'FB Inventory Leads',
        ],
      },
      { text: 'Premium connections', children: ['Dynamic OTT', 'Sold Reports'] },
      {
        text: 'Customer Match Back',
        children: ['Requires Sold report connection (Name, Email, Vin of customers)*'],
      },
    ],
  },
  {
    title: 'Agency',
    clientLinks: 'Multiple Clients',
    features: [
      {
        text: '1st party audiences',
      },
      {
        text: 'Daily pushes',
      },
      {
        text: 'Daily pulls',
      },
      {
        text: 'Unlimited connections',
        children: [
          'FB Audience',
          'FB Leads',
          'Google Audience',
          'Google Leads',
          'Google Sheets',
          'CSV',
          'FTP',
        ],
      },
      {
        text: 'Multiple inventory destinations',
        children: [
          'iSEM',
          'Google VA',
          'FB Inventory',
          'Dynamic Display Ads',
          'FB Inventory Leads',
        ],
      },
      { text: 'Premium connections', children: ['Dynamic OTT', 'Sold Reports'] },
      {
        text: 'Customer Match Back',
        children: ['Requires Sold report connection (Name, Email, Vin of customers)*'],
      },
    ],
  },
]

const onContactUsClick = (): void => {
  window.open("mailto:brian@demandlocal.com?subject=I'm interested in DL Link", '_blank')
}

const features = [
  {
    title: <div className={'font-semibold py-5'}>1st Party Audiences</div>,
    rows: [
      <RoundedCheck key={1} />,
      <RoundedCheck key={2} />,
      <RoundedCheck key={3} />,
      <RoundedCheck key={4} />,
    ],
    checks: [1, 1, 1, 1],
  },
  {
    title: <div className={'font-semibold py-5'}>Daily Pushes</div>,
    rows: [
      <RoundedCheck key={1} />,
      <RoundedCheck key={2} />,
      <RoundedCheck key={3} />,
      <RoundedCheck key={4} />,
    ],
    checks: [1, 1, 1, 1],
  },
  {
    title: <div className={'font-semibold py-5'}>Daily Pulls</div>,
    rows: [
      <RoundedCheck key={1} />,
      <RoundedCheck key={2} />,
      <RoundedCheck key={3} />,
      <RoundedCheck key={4} />,
    ],
    checks: [1, 1, 1, 1],
  },
  {
    title: <div className={'font-semibold py-5'}>Unlimited link</div>,
    rows: [<div key={1} />, <div key={2} />, <div key={3} />, <RoundedCheck key={4} />],
    checks: [0, 0, 0, 1],
  },
  {
    title: (
      <div className={'py-5'}>
        <div className={'font-semibold pb-3'}>Standard connections</div>
        <ul className={'flex flex-col gap-2'}>
          <li className={'flex flex-row gap-2 items-center'}>
            <div className={'bg-primary-persian-blue/10 rounded-full hidden xl:flex'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            Facebook Audience
          </li>
          <li className={'flex flex-row gap-2 items-center'}>
            <div className={'bg-primary-persian-blue/10 rounded-full hidden xl:flex'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            Facebook Leads
          </li>
          <li className={'flex flex-row gap-2 items-center'}>
            <div className={'bg-primary-persian-blue/10 rounded-full hidden xl:flex'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            Google Audience
          </li>
          <li className={'flex flex-row gap-2 items-center'}>
            <div className={'bg-primary-persian-blue/10 rounded-full hidden xl:flex'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            Google Leads
          </li>
          <li className={'flex flex-row gap-2 items-center'}>
            <div className={'bg-primary-persian-blue/10 rounded-full hidden xl:flex'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            Google Sheets
          </li>
          <li className={'flex flex-row gap-2 items-center'}>
            <div className={'bg-primary-persian-blue/10 rounded-full hidden xl:flex'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            CSV
          </li>
          <li className={'flex flex-row gap-2 items-center'}>
            <div className={'bg-primary-persian-blue/10 rounded-full hidden xl:flex'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            FTP
          </li>
        </ul>
      </div>
    ),
    rows: [
      <div className={'h-full px-4 text-center'} key={1}>
        1 connection (any)
      </div>,
      <div className={'h-full px-4 text-center'} key={1}>
        Up to 4 connections
      </div>,
      <div className={'h-full px-4 text-center'} key={2}>
        Unlimited connections
      </div>,
      <div className={'h-full px-4'} key={2}>
        <span className={'text-center'}>Per client connections</span>
        <ul className={'mt-2'}>
          <li className={'flex flex-row gap-2 items-center text-xs'}>
            <div className={'bg-primary-persian-blue/10 rounded-full'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            Custom CRM Push
          </li>
        </ul>
      </div>,
    ],
  },
  {
    title: (
      <div className={'py-5'}>
        <div className={'font-semibold pb-3'}>Inventory feed</div>
        <ul className={'flex flex-col gap-2'}>
          <li className={'flex flex-row gap-2 items-center'}>
            <div className={'bg-primary-persian-blue/10 rounded-full hidden xl:flex'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            iSEM
          </li>
          <li className={'flex flex-row gap-2 items-center'}>
            <div className={'bg-primary-persian-blue/10 rounded-full hidden xl:flex'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            Google VA
          </li>
          <li className={'flex flex-row gap-2 items-center'}>
            <div className={'bg-primary-persian-blue/10 rounded-full hidden xl:flex'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            Facebook Inventory
          </li>
          <li className={'flex flex-row gap-2 items-center'}>
            <div className={'bg-primary-persian-blue/10 rounded-full hidden xl:flex'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            Dynamic Display Ads
          </li>
          <li className={'flex flex-row gap-2 items-center'}>
            <div className={'bg-primary-persian-blue/10 rounded-full hidden xl:flex'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            Facebook Inventory Leads
          </li>
        </ul>
      </div>
    ),
    rows: [
      <div className={'h-full px-4 text-center'} key={1}>
        1 inventory destination
      </div>,
      <div className={'h-full px-4 text-center'} key={2}>
        1 inventory destination
      </div>,
      <div className={'h-full px-4 text-center'} key={3}>
        Multiple destinations
      </div>,
      <div key={4} />,
    ],
  },
  {
    title: (
      <div className={'py-5'}>
        <div className={'font-semibold pb-3'}>Premium connections</div>
        <ul className={'flex flex-col gap-2'}>
          <li className={'flex flex-row gap-2 items-center'}>
            <div className={'bg-primary-persian-blue/10 rounded-full hidden xl:flex'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            Dynamic OTT
          </li>
          <li className={'flex flex-row gap-2 items-center'}>
            <div className={'bg-primary-persian-blue/10 rounded-full hidden xl:flex'}>
              <ChevronRight className={'fill-primary-persian-blue'} />
            </div>
            Sold reports
          </li>
        </ul>
      </div>
    ),
    rows: [
      <div key={1} />,
      <div key={2} />,
      <div key={3} className={'h-full'}>
        <RoundedCheck />
      </div>,
      <div key={4} className={'h-full'}>
        <RoundedCheck />
      </div>,
    ],
  },
  {
    title: (
      <div className={'py-5'}>
        <div className={'font-semibold pb-3'}>Customer Match Back</div>
        <div>Requires Sold report connection (Name, Email, VIN of customers)</div>
      </div>
    ),
    rows: [
      <div key={1} />,
      <div key={2} />,
      <div key={3} className={'h-full'}>
        <RoundedCheck />
      </div>,
      <div key={4} className={'h-full'}>
        <RoundedCheck key={4} />
      </div>,
    ],
  },
  {
    title: <div className={'py-5'} />,
    rows: [
      <div key={1} className={'py-10'}>
        <Button variant={'secondary'} onClick={onContactUsClick}>
          Contact Us
        </Button>
      </div>,
      <div key={2} className={'py-10'}>
        <Button variant={'secondary'} onClick={onContactUsClick}>
          Contact Us
        </Button>
      </div>,
      <div key={3} className={'py-10'}>
        <Button variant={'secondary'} onClick={onContactUsClick}>
          Contact Us
        </Button>
      </div>,
      <div key={4} className={'py-10'}>
        <Button variant={'secondary'} onClick={onContactUsClick}>
          Contact Us
        </Button>
      </div>,
    ],
  },
]

const Pricing = (): JSX.Element => {
  const navigate = useNavigate()
  return (
    <div className={'h-full font-Spartan'}>
      <div>
        <header className={'relative'}>
          <div>
            <div
              className={
                'relative flex justify-between items-center md:px-10 px-7 pt-10'
              }>
              <LogoBlack
                className={'hidden md:flex cursor-pointer'}
                onClick={() => navigate('/')}
              />
              <LogoVerticalSimple className={'flex md:hidden '} />
              <div className={'gap-5 hidden md:flex'}>
                <a href={'/'} className="text-web-gray">
                  How it works
                </a>
                <Link to={'#'} className="text-web-gray">
                  Pricing
                </Link>
                <a
                  href={'https://www.demandlocal.com/'}
                  target={'_blank'}
                  rel={'noreferrer'}
                  className="text-web-gray">
                  Company
                </a>
              </div>
              <Button
                onClick={(e) => {
                  e.preventDefault()
                  navigate('/auth')
                }}>
                Get started
              </Button>
            </div>
          </div>
        </header>
        <section className={'mt-24 flex flex-col'}>
          <div className={'flex items-center justify-center'}>
            <h1 className={'text-5xl font-bold text-primary-xiketic'}>Pricing</h1>
          </div>
          <div className={'flex flex-col md:hidden px-7 py-5 gap-10'}>
            {featuresMobile.map((feature, index) => {
              return <PricingCardMobile feature={feature} key={index} />
            })}
          </div>
          <div
            className={
              'grid-cols-5 px-10 py-12 hidden md:grid auto-rows-[minmax(60px, auto)]'
            }>
            <div></div>
            <div className={'border-l-2 border-t-2 rounded-tl-xl'}>
              <div
                className={
                  'flex flex-col justify-center items-center xl:items-stretch px-4 xl:px-8 py-10'
                }>
                <div
                  className={
                    'flex flex-col items-center xl:flex-row xl:items-end h-16 xl:h-fit'
                  }>
                  <h2 className={'text-2xl xl:text-4xl font-bold text-primary-xiketic'}>
                    $ 199
                  </h2>
                  <span className={'text-sm'}> / location</span>
                </div>
                <div className={'mt-4 xl:text-base text-sm font-semibold'}>
                  2 Client links
                </div>
                <div className={'mt-2 xl:text-base text-sm xl:text-start text-center'}>
                  1 inbound, 1 outbound
                </div>
                <div className={'flex flex-col mt-4'}>
                  <Button variant={'secondary'} onClick={onContactUsClick}>
                    Contact Us
                  </Button>
                </div>
              </div>
            </div>
            <div className={'border-l-2 border-t-2'}>
              <div
                className={
                  'flex flex-col justify-between h-full items-center xl:items-stretch px-4 xl:px-8 py-10'
                }>
                <div>
                  <div
                    className={
                      'flex flex-col items-center xl:flex-row xl:items-end h-16 xl:h-fit'
                    }>
                    <h2 className={'text-2xl xl:text-4xl font-bold text-primary-xiketic'}>
                      $ 299
                    </h2>
                  </div>
                  <div
                    className={
                      'mt-4 xl:text-base text-sm font-semibold xl:text-start text-center'
                    }>
                    3-5 Client links
                  </div>
                </div>
                <div className={'flex flex-col mt-4'}>
                  <Button variant={'secondary'} onClick={onContactUsClick}>
                    Contact Us
                  </Button>
                </div>
              </div>
            </div>
            <div className={'border-l-2 border-t-2'}>
              <div
                className={
                  'flex flex-col justify-between h-full items-center xl:items-stretch px-4 xl:px-8 py-10'
                }>
                <div>
                  <div
                    className={
                      'flex flex-col items-center xl:flex-row xl:items-end h-16 xl:h-fit'
                    }>
                    <h2 className={'text-2xl xl:text-4xl font-bold text-primary-xiketic'}>
                      $ 499
                    </h2>
                  </div>
                  <div
                    className={
                      'mt-4 xl:text-base text-sm font-semibold xl:text-start text-center'
                    }>
                    Unlimited links 1 client
                  </div>
                </div>
                <div className={'flex flex-col mt-4'}>
                  <Button variant={'secondary'} onClick={onContactUsClick}>
                    Contact Us
                  </Button>
                </div>
              </div>
            </div>
            <div className={'border-l-2 border-t-2 border-r-2 rounded-tr-xl'}>
              <div
                className={
                  'flex flex-col justify-between h-full items-center xl:items-stretch px-4 xl:px-8 py-10'
                }>
                <div>
                  <div
                    className={
                      'flex flex-col items-center xl:flex-row xl:items-end h-16 xl:h-fit'
                    }>
                    <h2 className={'text-2xl xl:text-4xl font-bold text-primary-xiketic'}>
                      Agency
                    </h2>
                  </div>
                  <div
                    className={
                      'mt-4 xl:text-base text-sm font-semibold xl:text-start text-center'
                    }>
                    Multiple clients
                  </div>
                </div>
                <div className={'flex flex-col mt-4'}>
                  <Button variant={'secondary'} onClick={onContactUsClick}>
                    Contact Us
                  </Button>
                </div>
              </div>
            </div>
            {features.map((feature, i, featuresArr) => {
              const featureContainer = (
                <div
                  className={`flex text-xs xl:text-sm items-center px-10 rounded-l-xl ${
                    i % 2 === 0 && i !== featuresArr.length - 1
                      ? 'bg-cultured-gray'
                      : 'bg-white'
                  }`}>
                  {feature.title}
                </div>
              )
              const featureRows = feature.rows.map((row, index, arr) => {
                return (
                  <div
                    key={index}
                    className={`items-center font-medium text-xs xl:text-sm py-5 px-1 flex justify-center border-l-2 ${
                      i % 2 === 0 && i !== featuresArr.length - 1
                        ? 'bg-cultured-gray'
                        : 'bg-white'
                    } ${index === arr.length - 1 ? 'border-r-2' : ''} ${
                      i === featuresArr.length - 1
                        ? `border-b-2 ${index === 0 ? 'rounded-bl-xl' : ''} ${
                            index === arr.length - 1 ? 'rounded-br-xl' : ''
                          }`
                        : ''
                    }`}>
                    {row}
                  </div>
                )
              })
              return (
                <Fragment key={i}>
                  {featureContainer}
                  {featureRows}
                </Fragment>
              )
            })}
          </div>
        </section>
      </div>
      <LandingFooter />
    </div>
  )
}

export default Pricing
